import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

function RegisterPage() {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // --- NUEVO: Estado para ambas contraseñas ---
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }
        setLoading(true);
        try {
            await api.post('/auth/register', {
                username,
                email,
                password,
                nombre_completo: username, // Puedes cambiar esto si añades campo
            });
            navigate('/verificacion-enviada', { state: { email: email } });
        } catch (err) {
            console.error("Error al registrar:", err.response?.data || err);
            setError(err.response?.data?.detail || 'Ocurrió un error al registrarse.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            {/* <header className="auth-header-simple">
                 <img src="/images/logo-color.png" alt="Mercado Jopoi" style={{ height: '35px' }} />
            </header> */}

            <main className="auth-main">
                <div className="auth-layout">
                     <div className="auth-info">
                        <h1>Creá tu cuenta y empezá a intercambiar</h1>
                    </div>

                    <div className="auth-form-container">
                        <div className="auth-card-ml">
                            <form onSubmit={handleSubmit}>
                                {error && <div className="alert alert-danger mb-3">{error}</div>}

                                <div className="mb-3">
                                    <label className="form-label">Nombre de usuario</label>
                                    <input type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required disabled={loading} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} autoComplete="email" />
                                </div>

                                {/* --- CAMPO DE CONTRASEÃ‘A 1 MODIFICADO --- */}
                                <div className="mb-3">
                                    <label className="form-label">Contraseña</label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            disabled={loading}
                                            autoComplete="new-password"
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                                        </button>
                                    </div>
                                </div>
                                {/* --- FIN DE LA MODIFICACIÓN --- */}

                                {/* --- CAMPO DE CONTRASEÃ‘A 2 MODIFICADO --- */}
                                <div className="mb-3">
                                    <label className="form-label">Confirmar Contraseña</label>
                                    <div className="input-group">
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            className="form-control"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                            disabled={loading}
                                            autoComplete="new-password"
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            <i className={showConfirmPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                                        </button>
                                    </div>
                                </div>
                                {/* --- FIN DE LA MODIFICACIÓN --- */}

                                <div className="d-grid gap-2 mt-4 mb-3">
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Creando cuenta...' : 'Crear cuenta'}
                                    </button>
                                </div>
                            </form>

                            <div className="link-container">
                                <Link to="/login">¿Ya tienes cuenta? Ingresa</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default RegisterPage;
